import React, { useEffect } from 'react'
import { UserColumns, IListParams, UserTypes, IUser, UserRole } from '../../../shared/models/adminModels';
import { connect } from 'react-redux';
import { getUsersList, updateManageSearchParams } from '../../../store/actions/management';
import Table from '../../../components/Table';
import { Row } from 'react-table';
import moment from 'moment';
import { IModulesPermissions } from '../../../shared/models/rolesPermissionModel';
import { get } from 'lodash';
import BackButton from '../../../components/BackButton';

const userColumns = [
    {
        Header: 'Name',
        accessor: UserColumns.UserName,
    },
    {
        Header: 'Email',
        accessor: UserColumns.Email,
    },
    {
        Header: 'Last Login',
        accessor: UserColumns.LastLoginDateTime,
        Cell: (props: any) => props.cell.value ? moment(props.cell.value*1000).format('DD/MM/YYYY hh:mm a') : '-'
    },
    {
        Header: 'Role',
        accessor: UserColumns.UserType,
        Cell: (props: any) => {
            const { value } = props.cell;
            return UserRole[value] || '-';
        }
    },
    {
        Header: 'Status',
        accessor: UserColumns.Active,
        Cell: (props: any) => (
                <div className="active-status-wrp d-flex">
                    {/* {props.cell.value ? 'Active' : 'Inactive'}  */}
                    <span className={ (props.cell.value ? 'active-status' : 'inactive-status') + ' ml-2'}></span>
                </div>
        )
    },
];

interface IProps {
    permission:IModulesPermissions;
    history:any;
    getUsersList: (param: IListParams) => void,
    userList: any,
    isLoading: boolean,
    updateManageSearchParams: (params: IListParams, userType: UserTypes) => void
}

const User = (props:IProps) => {
    const { 
        totalPages: userTotalPages, 
        data: userData, 
        pageSize :userPageSize, 
        orderBy: userOrderBy,
        currentPage: userCurrentPage,
        searchParameter: userSearchParameter,
        sortType: userSortType
    } = props.userList;

    let userList: any = [];

    if (userData.length) {
        userList = props.userList.data.map((user: IUser) => {
            return {
                [UserColumns.Id] : user.id,
                [UserColumns.UserName] : user.userName,
                [UserColumns.UserType] : user.userType ,
                [UserColumns.Email]: user.email,
                [UserColumns.Active]: user.active,
                [UserColumns.LastLoginDateTime]: user.lastLoginDateTime
            }
        });
    }

     // get usersList
    const getUserList = async (saerchParams: IListParams) => {
        await props.getUsersList(saerchParams);
    }

    const onRowClick = (row: Row<any>) => {
        props.history.push(`/manage-user/${row.original.id}`)
    }
    useEffect(() => {
        getUserList({
            currentPage: userCurrentPage,
            pageSize: userPageSize,
            orderBy: userOrderBy,
            searchParameter: userSearchParameter,
            sortType: userSortType
        });
    }, []);
    const canEdit = get(props.permission.manageUsers,'edit',false);
    const canAdd = get(props.permission.manageUsers,'create',false);
    return (
        <div className="container-fluid width-control">
          <div className="page-header">
              <h1>User Management</h1>
               <BackButton/>
                {canAdd && <button type="button" className="btn btn-primary ml-auto" onClick={() => props.history.push('/manage-user')}>Add</button> }
          </div>


          <div className="page-content">
              <div className="row">
                  <div className="col-xl-12">
                      <div className="info-box ">
                        <div className="table-responsive p-1 management-tbl">
                            <Table
                                    headerclass={"box-shaddow box-padding border-btm-blue"}
                                    rowClass={"box-shaddow box-padding"}
                                    columns={userColumns} 
                                    data={userList}
                                    fetchData={getUserList}
                                    totalPages={userTotalPages}
                                    isLoading={props.isLoading}
                                    currentPage={userCurrentPage}
                                    pageSize={userPageSize}
                                    orderBy={userOrderBy}
                                    searchParameter={userSearchParameter}
                                    sortType={userSortType}
                                    userType={UserTypes.USER}
                                    onRowClick={canEdit ? onRowClick : undefined}
                                    updateSearchParams={props.updateManageSearchParams}
                                />
                          </div>
                      </div>
                  </div>

               
              </div>
          </div>
        </div> 
    )
}

const mapStateToProps = (state: any) => {
    return ({
        permission: state.auth.user.permission,
        userList: state.managementReducer.userList,
        isLoading: state.common.isLoading
    })
}

const mapDispatchToProps = (dispatch: any) => ({
    getUsersList: (params: IListParams) => dispatch(getUsersList(params)),
    updateManageSearchParams: (params: IListParams, userType: UserTypes) => dispatch(updateManageSearchParams(params, userType))
});

export default connect(mapStateToProps, mapDispatchToProps)(User)
